<template>
  <div>
    <span>
      {{ rowData.secondRecipientName }}
    </span>
    <br />
    <span>
      {{ rowData.secondRecipientNumber }}
    </span>
  </div>
</template>

<script>
export default {
  name: 'second-recipient-column',
  props: {
    rowData: {
      type: Object,
      required: true
    }
  }
}
</script>
